import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  /* istanbul ignore next */
  public goTo(url: string) {
    window.location.href = url;
  }

  public openTab(url: string) {
    window.open(url, '_blank');
  }
}
